import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerDto } from "app/models";

@Component({
    selector: 'change-standard-role-order-modal',
    templateUrl: './change-standard-role-order.modal.html',
    styleUrls: ['./change-standard-role-order.modal.scss'],
})
export class ChangeStandardRoleOrderModal implements OnInit {
    

    @Input() currentOrder: number;

    @Input() player: PlayerDto;

    @Input() maxOrder: number;

    formGroup: FormGroup;
   
    constructor(public activeModal: NgbActiveModal) {
    }

    ngOnInit(): void {
        this.buildFormGroup();
    }

    onSubmit() {
            var number = this.formGroup.controls.numberFormControl.value;

            if (!number || number <= 0 || number > this.maxOrder) {
                return;
            }

            this.activeModal.close(number);
    }

    onSelectNumber(val: number) {
        this.formGroup.controls.numberFormControl.setValue(val);
    }

    private buildFormGroup() {
        this.formGroup = new FormGroup({
            numberFormControl: new FormControl(this.currentOrder)
        });
    }
}